/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Stack, Heading, Box, Section, Grid } from '@rebeldotcom/components'
import { isInternic } from '@rebeldotcom/ui'
import ConfiguratorSelect from './configurator-select'

const ConfigProps = {
  children: PropTypes.node.isRequired,
  customText: PropTypes.shape({
    existing: PropTypes.shape({
      subtitle: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }).isRequired,
    new: PropTypes.shape({
      subtitle: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }).isRequired,
    title: PropTypes.string.isRequired,
  }),
  hideOptionsSelector: PropTypes.bool.isRequired,
  onToggle: PropTypes.func,
}

const defaultProps = {
  customText: {
    title: 'Connect to an existing domain',
    existing: {
      title: 'EXISTING CUSTOMERS',
      subtitle: 'Connect to an existing domain',
    },
    new: {
      title: 'NEW CUSTOMERS',
      subtitle: 'Search and connect a new domain',
    },
  },
  onToggle: null,
}

const NewOrExistingCustomerConfig = ({
  hideOptionsSelector,
  customText,
  onToggle,
  children,
}) => {
  const [optionSelected, setOptionSelected] = useState(0)
  return (
    <Box minHeight="560px" mt={[1, 5]} width="100%">
      <Section
        bg={isInternic ? 'blueDark' : 'deepKoamaru'}
        color={isInternic ? 'white' : 'deepKoamaru'}
        containerProps={{
          maxWidth: 'containers.sm',
        }}
        mt={2}
        py={4}
      >
        {/* START OPTIONS */}
        <Stack
          alignItems="center"
          flexWrap="wrap"
          justifyContent="center"
          mb={3}
          mt={[1, 3]}
          width="100%"
        >
          <Heading color="white" mb={4} textAlign="center" variant="tera">
            {customText.title}
          </Heading>

          {!hideOptionsSelector && (
            <Grid
              gridGap={[0, 2]}
              gridRowGap={[3, 0]}
              gridTemplateColumns={['1fr', `repeat(2, 1fr)`]}
              maxWidth="containers.sm"
              mb={[3, 1]}
              mt={2}
            >
              <ConfiguratorSelect
                key="configurator-select-new"
                index={0}
                optionSelected={optionSelected}
                setOptionSelected={i => {
                  setOptionSelected(i)
                  if (onToggle) onToggle(true)
                }}
                subtitle={customText.new.subtitle}
                title={customText.new.title}
              />

              <ConfiguratorSelect
                key="configurator-select-existing"
                index={1}
                optionSelected={optionSelected}
                setOptionSelected={i => {
                  setOptionSelected(i)
                  if (onToggle) onToggle(false)
                }}
                subtitle={customText.existing.subtitle}
                title={customText.existing.title}
              />
            </Grid>
          )}
          <Box color={isInternic ? 'white' : 'deepKoamaru'} mt={2} width="100%">
            {children}
          </Box>
        </Stack>
      </Section>
    </Box>
  )
}

NewOrExistingCustomerConfig.propTypes = ConfigProps
NewOrExistingCustomerConfig.defaultProps = defaultProps

export default NewOrExistingCustomerConfig
